import GlobalAPICall from '../../GlobalComponents/GlobalAPICall';
import { filter, switchMap } from 'rxjs/operators';

export default class ChangePasswordProxy {
  constructor(authService) {
    this.authService = authService;
  }

  set(data) {
    return this.authService
      .getTokenObservable()
      .pipe(filter((token) => !!token))
      .pipe(
        switchMap((token) =>
          GlobalAPICall.putObservable(process.env.REACT_APP_AUTH_API_URL + '/api/Password', data, {
            headers: {
              Authorization: 'Bearer ' + token,
              'Content-Type': 'application/json',
            },
          })
        )
      );
  }
}
